var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "upgrade" } },
    [
      _c("div", { staticClass: "bg" }),
      _c("c-header-return", {
        attrs: { isCustom: true, isBtnShow: true },
        scopedSlots: _vm._u([
          {
            key: "customTitle",
            fn: function () {
              return [
                _c("div", { staticClass: "flex flex-ver" }, [
                  _c("p", { staticClass: "title-con-middle-title" }, [
                    _vm._v("经典升级"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "title-con-middle flex flex-center-1",
                      on: {
                        click: function ($event) {
                          _vm.notice_modal_show = true
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "case-title-rule-item",
                        attrs: {
                          src: require("../../../assets/images/help_fill.png"),
                        },
                      }),
                      _c("p", [_vm._v("游戏规则")]),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "main-top-conItem flex flex-center-1" }, [
        _c("div", { staticClass: "main-top-con" }, [
          !_vm.$screen.mobile
            ? _c(
                "div",
                { staticClass: "item-con-1 flex flex-col flex-center-1" },
                [
                  _c("c-svg", {
                    staticClass: "item-box",
                    attrs: { src: "upgrade-item.svg" },
                  }),
                  _c("div", { staticClass: "item-name" }, [_vm._v("随机饰品")]),
                  _c("div", { staticClass: "name-desc" }, [
                    _vm._v("失败获得一件随机饰品"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "flex flex-center-1" },
            [
              _c("c-turntable", {
                ref: "turntable",
                attrs: {
                  upgrade_success_rate: _vm.upgrade_success_rate,
                  minRollNum: _vm.minRollNum,
                  maxRollNum: _vm.maxRollNum,
                  roll: _vm.roll,
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "mobile-style" }, [
            _vm.$screen.mobile
              ? _c(
                  "div",
                  { staticClass: "item-con-1 flex flex-col flex-center-1" },
                  [
                    _c("c-svg", {
                      staticClass: "item-box",
                      attrs: { src: "upgrade-item.svg" },
                    }),
                    _c("div", { staticClass: "item-name" }, [
                      _vm._v("随机饰品"),
                    ]),
                    _c("div", { staticClass: "name-desc" }, [
                      _vm._v("失败获得一件随机饰品"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "item-con flex flex-col flex-center-1 active",
                class: "rarity" + _vm.targetData.rarity,
              },
              [
                _c("div", { staticClass: "item-name-con" }, [
                  _c("div", [
                    _c("div", { staticClass: "weapon-name" }, [
                      _vm._v(
                        _vm._s(_vm._f("GetItemName")(_vm.targetData.name))
                      ),
                    ]),
                    _c("div", { staticClass: "skin-name" }, [
                      _vm._v(
                        _vm._s(_vm._f("GetItemSkinName")(_vm.targetData.name))
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "dur" }, [
                      _vm._v(
                        _vm._s(_vm._f("GetItemDuration")(_vm.targetData.name))
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "item-pic-con" }, [
                  _vm.targetData.imgUrl
                    ? _c("img", {
                        staticClass: "active",
                        attrs: {
                          src: _vm._f("imgfilter")(_vm.targetData.imgUrl),
                        },
                      })
                    : _vm._e(),
                ]),
                _c("c-svg", {
                  staticClass: "item-bg",
                  attrs: { src: "itembg.svg", fill: "rgb(0, 0, 0,.2)" },
                }),
                _c("div", { staticClass: "item-price" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("物品价值：")]),
                  _c(
                    "div",
                    { staticClass: "price" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("conversion")(_vm.targetData.price)) +
                          " "
                      ),
                      _c("c-svg", {
                        attrs: {
                          src: "bill.svg",
                          width: "12",
                          height: "12",
                          fill: "#4762f2",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "main-bottom-conItem flex flex-col flex-center-1" },
        [
          _c("div", { staticClass: "main-bottom-center-item" }, [
            _c(
              "button",
              {
                staticClass: "flex flex-center-1",
                attrs: { disabled: _vm.isLotterying },
                on: {
                  click: function () {
                    return _vm.send_trade_api()
                  },
                },
              },
              [
                _c("span", { staticStyle: { "margin-left": "5px" } }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.totalPrice) +
                      " + " +
                      _vm._s(_vm.upgradeFeePrice) +
                      "手续费 "
                  ),
                ]),
                _vm.isHappyCoin
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "12px",
                          "margin-left": "2px",
                        },
                      },
                      [_vm._v("欢乐豆")]
                    )
                  : _vm._e(),
              ]
            ),
            _c("div", { staticClass: "main-bottom-center-item-item" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("请拖动选择滑动概率"),
                  ]),
                  _c("Slider", {
                    attrs: {
                      step: 1,
                      min: 5,
                      max: 75,
                      "tip-format": function (val) {
                        return "成功率:" + val + "%"
                      },
                    },
                    on: { "on-change": _vm.on_slider_change },
                    model: {
                      value: _vm.upgrade_success_rate,
                      callback: function ($$v) {
                        _vm.upgrade_success_rate = $$v
                      },
                      expression: "upgrade_success_rate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mobile-left-con-mobile flex flex-center-2" },
                [
                  _c("div", { staticClass: "mobile-left-con-mobile-item" }, [
                    _c("p", [_vm._v("使用余额")]),
                    _c("div", { staticClass: "input-box" }, [
                      _c("input", {
                        staticStyle: { color: "#F5B844" },
                        attrs: { type: "number", readonly: "" },
                        domProps: { value: _vm.totalPrice },
                        on: {
                          blur: function ($event) {
                            return _vm.onUseBalanceInputChange($event)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "mobile-left-con-mobile-item" }, [
                    _c("p", [_vm._v("ROLL中奖下限")]),
                    _c("div", { staticClass: "input-box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.minRollNum,
                            expression: "minRollNum",
                          },
                        ],
                        attrs: { type: "number" },
                        domProps: { value: _vm.minRollNum },
                        on: {
                          blur: _vm.minRollNumHandler,
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.minRollNum = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "mobile-left-con-mobile-item" }, [
                    _c("p", [_vm._v("ROLL中奖上限")]),
                    _c("div", { staticClass: "input-box" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.maxRollNum,
                            expression: "maxRollNum",
                          },
                        ],
                        attrs: { type: "number" },
                        domProps: { value: _vm.maxRollNum },
                        on: {
                          blur: _vm.maxRollNumHandler,
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.maxRollNum = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _vm.itemHistory.data && _vm.itemHistory.data.length > 0
        ? _c(
            "div",
            { staticClass: "main-history-item flex flex-col flex-center-1" },
            [
              _c("div", { staticClass: "history-item" }, [
                _c("h2", { staticClass: "history-title" }, [
                  _vm._v("最近掉落"),
                ]),
                _c(
                  "div",
                  { staticClass: "history-box" },
                  _vm._l(_vm.itemHistory.data, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "history-box-item" },
                      [
                        _c("c-award", {
                          attrs: {
                            rarity: item.item.rarity,
                            picture: item.item.itemPic,
                            rate: item.rate,
                            name: item.item.name,
                            price: item.item.sellPrice,
                            width: "100%",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c("c-RewardModal", { ref: "upgrade_reward_ui" }),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "经典升级玩法说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(
                    " 1、您会随机获得一件饰品，或有机会获得一件心仪的饰品。※总成功率不得低于 5%。 "
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    " 2、每次成功概率为相互独立的，例如 30% 的成功概率升级 3 次，但不代表有 90% 的机会。 "
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.prize.animate,
              expression: "prize.animate",
            },
          ],
          staticClass: "case-animation-modal",
        },
        [
          _c("c-animation", {
            ref: "runbox",
            on: { on_finished: _vm.endCallBack },
          }),
        ],
        1
      ),
      _vm.prize.animate ? _c("div", { staticClass: "shadow_box" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }